// extracted by mini-css-extract-plugin
module.exports = {"menu":"_2ZUfc3exqVAVq82-RXmmRy","item":"_2wOD5aJH3F-IjQcHIh8Udc","itemHighlighted":"_3qy5Vy5niTA5YAR6-x9PZ0","timeInput":"_34-pLs8rXfQ3pFVMFFpFqG"};